export default IconAntennaBars3 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-antenna-bars-3" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M6 18l0 -3" />
  <path d="M10 18l0 -6" />
  <path d="M14 18l0 .01" />
  <path d="M18 18l0 .01" />
</svg>`;